export default __webpack_public_path__ + "static/media/main_info_data_07.90f6246a.png";